import { HedgedPositionProps, HedgeProps, MarketProps, OrderProps, PositionProps } from "../../../store/types/mk_svc"

export let current_hedges:HedgeProps[] = []


export const hedge_getHedgesFromPositions = (orders:OrderProps[], markets:MarketProps[]):HedgeProps[] => {
    //1) Set up arrays to store hedges
    let hedges:HedgeProps[] = []
    let hedgeable_positions:Array<OrderProps[]> = []
    //Only allow real money orders for hedging
    orders = orders.filter(o => o.market_type === 'FOR_MONEY' && o.resolution_status !== 'closed')

    //2) Get the unique markets (and common var_1s) that are eligible to be hedged 
    let orders_with_positions = orders.filter(o => o.positions[0])
    let unique_markets = [ ...new Set(orders_with_positions.map(o => `${o.event_id}:${o.event_type}:${o.market_id}:${Math.abs(o.var_1)}`)) ]
   
    //3) For each unique market and var_1 combo, determin if there are positions on the opposite side of each other
    //If so, then store them into an array of orders
    unique_markets.map(id => {
        //1) Get orders that are associated with the market
        let market_orders = orders_with_positions.filter(o => `${o.event_id}:${o.event_type}:${o.market_id}:${Math.abs(o.var_1)}` == id)
        if(market_orders.length < 2){ return } //Impossible to hedge with less than 2 orders
        let unique_sides = [ ...new Set(market_orders.map(o => o.side)) ]
        if(unique_sides.length < 0){ return } //Must have more than 1 side

        hedgeable_positions.push(market_orders)
    })

    //Return nothing if there are no hedgeable positions
    if(hedgeable_positions.length === 0){ return [] }

    //Awesome! We have some hedgeable positions
    hedgeable_positions.map(hp => {
        //Get an empty hedge object to store our hedges
        let hedge = hedge_getEmptyHedge()
        let market = markets.find(m => m.market_id == hp[0].market_id)
        if(!market){ return } //Error out if there is no market
        if(market.level !== 'event'){ return } //Dont if level is not event

        let trade_side_orders = hp.filter(o => o.side == market?.trade_side)
        let o_side_orders = hp.filter(o => o.side != market?.trade_side)
        
        //New
        if(market.type == 'Spread'){
            if(!trade_side_orders[0]){ return } //Make sure there is at least 1 trade side order
            o_side_orders = o_side_orders.filter(o => o.var_1 == trade_side_orders[0].var_1 * -1)
        }

        if(trade_side_orders.length === 0 || o_side_orders.length === 0){ return }



        hedge.market_id = market.market_id
        hedge.market_type = hp[0].market_type
        hedge.var_1 = Math.abs(hp[0].var_1)
        hedge.player_id = hp[0].player_id
        hedge.event_id = hp[0].event_id
        hedge.event_type = hp[0].event_type
        hedge.market_id = hp[0].market_id
       


        //Set up arrays to store the positions on each side of the hedge
        let trade_side_positions:PositionProps[] = []
        let o_side_positions:PositionProps[] = [] 
        trade_side_orders.map(o => {
            trade_side_positions = trade_side_positions.concat(o.positions)
        })
        o_side_orders.map(o => {
            o_side_positions = o_side_positions.concat(o.positions)
        })

        //Calculate the winnings from each outcome (side a wins, side b wins, or draw)
        let trade_side_pot_winnings = trade_side_positions.reduce((a,b) => a + b.potential_winnings, 0)
        let o_side_pot_winnings = o_side_positions.reduce((a,b) => a + b.potential_winnings, 0)
        let draw_winnings = trade_side_positions.concat(o_side_positions).reduce((a,b) => a + b.stake, 0)

        //Get the minimum payout possible of the 3 outcomes which is the hedged amount
        let hedged_amt = Math.min(trade_side_pot_winnings, o_side_pot_winnings)
        if(isNaN(hedged_amt)){ return }
        hedge.hedged_amt = hedged_amt

        //Now lets cals out hedged positions
        let hedged_positions:HedgedPositionProps[] = []
        
        trade_side_positions.map(p => {
            //Need to determine the weight of the position on the total potential winnings and reduce the stake proportionately
            let pct = p.potential_winnings / trade_side_pot_winnings
            //console.log(hedged_amt, pct, p.probability)
            let stake_from_hedge = hedged_amt * pct * p.probability
            hedge.stake_reduction += stake_from_hedge 
            let new_stake = p.stake - stake_from_hedge
            hedged_positions.push({
                hedge_id:'',
                hedged_position_id: '',
                position_id: p.position_id,
                original_stake: p.stake,
                new_stake,
                delayed_cash_draw: 0,
                delayed_cash_no_draw: 0,
                original_potential_winnings: p.potential_winnings,
                new_potential_winnings: new_stake / p.probability,
                status: 'pending',
                create_datetime:'',
                last_update_datetime:''
            })
        })

        o_side_positions.map(p => {
            let pct = p.potential_winnings / o_side_pot_winnings
            let stake_from_hedge = hedged_amt * pct * p.probability
            hedge.stake_reduction += stake_from_hedge 
            let new_stake = p.stake - stake_from_hedge
            hedged_positions.push({
                hedge_id:'',
                hedged_position_id: '',
                position_id: p.position_id,
                original_stake: p.stake,
                new_stake,
                delayed_cash_draw: 0,
                delayed_cash_no_draw: 0,
                original_potential_winnings: p.potential_winnings,
                new_potential_winnings: new_stake / p.probability,
                status: 'pending',
                create_datetime:'',
                last_update_datetime:''
            })
        })


        //Cash rcvd will be the lower of the hedged amount or the reduction in stake
        let cash_rcvd = Math.min(hedge.stake_reduction, hedged_amt, draw_winnings)
        if(isNaN(cash_rcvd) || cash_rcvd < 0.01){ return }
        hedge.cash_rcvd = cash_rcvd
        let delayed_cash = hedged_amt - hedge.stake_reduction
        let total_og_stake = hedged_positions.reduce((a,b) => a + b.original_stake, 0)
        let delayed_cash_draw = 0, delayed_cash_no_draw = 0;
        if(delayed_cash < 0){
            delayed_cash_draw = delayed_cash * -1
            //hedge.delayed_cash_draw = delayed_cash * -1 //Need to make positive
        } else {
            delayed_cash_no_draw = delayed_cash
            //hedge.delayed_cash_no_draw = delayed_cash
        }
        hedge.delayed_cash_draw = delayed_cash_draw
        hedge.delayed_cash_no_draw = delayed_cash_no_draw

        hedged_positions.map(hp => {
            let pct_of_total = hp.original_stake / total_og_stake
            hp.delayed_cash_draw = pct_of_total * delayed_cash_draw
            hp.delayed_cash_no_draw = pct_of_total * delayed_cash_no_draw
            return hp
        })

        hedges.push({ ...hedge, hedged_positions:hedged_positions })
    })

    return hedges

}


export const hedge_getEmptyHedge = ():HedgeProps => {
    let uuid = Math.floor(Math.random() * 100000000)
    return {
        hedge_id: uuid.toString(),
        hedged_amt: 0,
        event_id: '',
        event_type: '',
        market_id: '',
        var_1: 0,
        delayed_cash_draw: 0,
        delayed_cash_no_draw: 0,
        cash_rcvd: 0,
        stake_reduction: 0,
        market_type: 'FOR_MONEY',
        create_datetime: '',
        last_udpate_datetime:'',
        player_id: '',
        status: 'pending'
    }
}
